// TableCell component override
export default function TableCell(theme: any) {
  return {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          padding: '16px',
          borderColor: theme.palette.divider
        },
        head: {
          fontWeight: 600,
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.grey[50]
        }
      }
    }
  };
}
